export const LOGIN_ALLOWED_LEAGUES = [189];
